var map = {
	"./bot-logo-1.png": "addc",
	"./bot-logo-2.png": "4847",
	"./bot-logo-3.png": "7ec7",
	"./bot-logo-4.png": "7837",
	"./devOps-focus.png": "f363",
	"./event-driven.png": "5cd8",
	"./knwl-logo-1.png": "37c7",
	"./knwl-logo-2.png": "b472",
	"./knwl-logo-3.png": "33e2",
	"./knwl-logo-4.png": "0992",
	"./less-hallucination.png": "21bc",
	"./multimodal.png": "13d8",
	"./secure-access.png": "ca30",
	"./tool-logo-1.png": "38f5",
	"./tool-logo-2.png": "175d",
	"./tool-logo-3.png": "ca82",
	"./tool-logo-4.png": "6e16",
	"./workspaceImg.png": "4d27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d831";